import { defineStore } from "pinia";
// import api from "@/api";
import { useMasterDataStore } from "./MasterDataStore";
export const useCutiJenisStore = defineStore("cutiJenisStore", {
  state: () => ({
    data: null,
  }),
  onInit() {
    this.get();
  },
  persist: true,
  getters: {
    filter() {
      return this.data.filter((g) => g.nama);
    },
  },
  actions: {
    async get() {
      // if (!this.data) {
      //   try {
      //      const response = await api.get('/cutiJenis');
      //     this.data = response.data;
      //     return this.data;
      //     // this.data.unshift({ id: null, nama: "" });
      //   } catch (error) {
      //     console.error('cutiJenisStore Error fetching:', error);
      //   }
      // }
      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.cutiJenis || [];
        console.log("cutijenis", this.data);
      }
      return this.data;
    },
    // reset(){
    //     this.data = null;
    //     this.get();
    // }
    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
});
